export interface Project {
  id: string
  title: string
  description: string
  tech: string[]
  githubUrl?: string
  liveUrl?: string
}

// Add new projects here — when you wire up the Express/MongoDB backend later,
// replace this with a fetch call.
export const projects: Project[] = [
  {
    id: 'clone-cowrywise',
    title: 'CowryWise Clone',
    description:
      'A pixel-faithful clone of the CowryWise fintech investment platform — built to study micro-interactions, layout systems, and product UX in modern fintech apps.',
    tech: ['React', 'JavaScript', 'Tailwind CSS', 'Responsive Design'],
    githubUrl: 'https://github.com/Dev-emmy-001/clone-cowrywisee',
    liveUrl: 'https://clonecowrywis.netlify.app/',
  },
  {
    id: 'mantle-project',
    title: 'Mantle Ecosystem',
    description:
      'A Web3 project built around the Mantle network — exploring on-chain interactions, wallet connections, and ecosystem-level dApp integrations on an L2.',
    tech: ['React', 'Web3', 'Mantle Network', 'Ethers.js'],
    githubUrl: 'https://github.com/Dev-emmy-001/mantleproject',
    liveUrl: 'https://mantlecosystem.netlify.app/',
  },
  {
    id: 'grade-checker',
    title: 'Sign-In Grade Checker',
    description:
      'A student grade-checking portal with authentication — users can sign in, see their academic scores, and track performance through a clean dashboard.',
    tech: ['React', 'Authentication', 'JavaScript', 'CSS'],
    githubUrl: 'https://github.com/Dev-emmy-001/signin_gradechecker',
    liveUrl: 'https://devemmygradechecker.netlify.app/',
  },
  {
    id: 'pwa-web3',
    title: 'Real Finance (PWA · Web3)',
    description:
      'A Progressive Web App combining Web3 functionality with offline-first capabilities — installable, fast, and crypto-enabled finance experience.',
    tech: ['React', 'PWA', 'Web3', 'Service Workers'],
    githubUrl: 'https://github.com/Dev-emmy-001/PWA-web3-project',
    liveUrl: 'https://realfinanceofficial.netlify.app/',
  },
  {
    id: 'my-portfolio-v1',
    title: 'My Portfolio (v1)',
    description:
      'My first developer portfolio — a clean showcase of who I am, what I build, and how to reach me. Built with a focus on simplicity and performance.',
    tech: ['React', 'JavaScript', 'CSS', 'Vercel'],
    githubUrl: 'https://github.com/Dev-emmy-001/my-portfolio',
  },
  {
    id: 'fashion-shop',
    title: 'Fashion Shop',
    description:
      'A polished online fashion storefront focused on product discovery, visual merchandising, and an easy shopping experience.',
    tech: ['React', 'E-commerce', 'Responsive Design'],
    liveUrl: 'https://fashionshoppp.netlify.app/',
  },
  {
    id: 'nexus-portal',
    title: 'Nexus Portal',
    description:
      'A modern portal experience that brings information, navigation, and user actions into one streamlined workspace.',
    tech: ['React', 'JavaScript', 'Dashboard UI'],
    liveUrl: 'https://nexusportalst.netlify.app/',
  },
  {
    id: 'printivo-clone',
    title: 'Printivo Clone',
    description:
      'A print-services interface inspired by the modern ordering experience, with clear product browsing and strong visual hierarchy.',
    tech: ['React', 'UI Design', 'Responsive Design'],
    liveUrl: 'https://printivoo.netlify.app/',
  },
  {
    id: 'cowry-level-two',
    title: 'Cowry Level 2',
    description:
      'An expanded CowryWise-inspired product build showcasing a refined fintech interface and responsive customer flows.',
    tech: ['React', 'Fintech UI', 'Tailwind CSS'],
    liveUrl: 'https://cowrylevel2pro.netlify.app/',
  },
  {
    id: 'figma-exclusive',
    title: 'Figma Exclusive',
    description:
      'A design-led web experience translating a high-fidelity visual concept into a responsive, production-style interface.',
    tech: ['React', 'Figma', 'CSS', 'Responsive Design'],
    liveUrl: 'https://figmaexclusive.netlify.app/',
  },
]
